// extracted by mini-css-extract-plugin
export default {"issueSection":"IssueSection_issueSection__o1Zrk","issueSectionImg":"IssueSection_issueSectionImg__gLdAX"};